import {
  Injectable
} from '@angular/core';


export class SkyWaitPageAdapterService {

  public addPageWaitEl() {
    document.body.appendChild(document.createElement('sky-wait-page'));
  }

  public removePageWaitEl() {
    document.body.removeChild(document.querySelector('sky-wait-page'));
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
